import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { CrsSearchModule } from '../crs-search/crs-search.module';
import { GridModule } from '../grid/grid.component.module';
import { CreateProjectContentComponent } from './create-project-content/create-project-content.component';
import { CreateProjectDialogComponent } from './create-project-dialog.component';

@NgModule({
    declarations: [CreateProjectContentComponent, CreateProjectDialogComponent],
    imports: [
        CommonModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
        FormsModule,
        ReactiveFormsModule,
        CrsSearchModule,
        GridModule,
    ],
    exports: [CreateProjectContentComponent, CreateProjectDialogComponent],
})
export class CreateProjectDialogModule {}
